import { useState, useRef } from 'react';

import { Menu, MenuItem, MenuList, Paper, Popper, ListItemText, ListItemIcon } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function SubMenu({ label, children }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    return (
        <>
            <MenuItem
                ref={ref}
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                sx={{ justifyContent: 'space-between' }}>
                <ListItemText>{label}</ListItemText>
                <ListItemIcon sx={{ minWidth: 0 }}>
                    <ChevronRightIcon fontSize='small' />
                </ListItemIcon>
            </MenuItem>
            <Popper open={open} anchorEl={ref.current} placement='right-start' style={{ zIndex: 1300 }}>
                <Paper
                    elevation={0}
                    variant='outlined'
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}>
                    <MenuList>{children}</MenuList>
                </Paper>
            </Popper>
        </>
    );
}

// item shape: { label, onClick, disabled? } or { label, sub: [{ label, onClick, disabled? }] }
function AdminMenuBar({ apiItems = [], editItems = [] }) {
    const [apiAnchor, setApiAnchor] = useState(null);
    const [editAnchor, setEditAnchor] = useState(null);
    const closeApi = () => setApiAnchor(null);
    const closeEdit = () => setEditAnchor(null);

    const menuProps = { elevation: 0, variant: 'outlined', sx: { maxHeight: 'none' } };

    const renderItems = (items, onClose) =>
        items.map((item, i) =>
            item.sub ? (
                <SubMenu key={i} label={item.label}>
                    {renderItems(item.sub, onClose)}
                </SubMenu>
            ) : (
                <MenuItem
                    key={i}
                    disabled={!!item.disabled}
                    onClick={() => {
                        item.onClick();
                        onClose();
                    }}>
                    {item.label}
                </MenuItem>
            ),
        );

    return (
        <>
            <MenuList
                disablePadding
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    borderBottom: 1,
                    borderColor: 'divider',
                    flexShrink: 0,
                    p: 0,
                    bgcolor: 'action.hover',
                }}>
                {apiItems.length > 0 && (
                    <MenuItem
                        dense
                        onClick={(e) => setApiAnchor(e.currentTarget)}
                        selected={!!apiAnchor}
                        sx={{ typography: 'body2' }}>
                        Command
                    </MenuItem>
                )}
                {editItems.length > 0 && (
                    <MenuItem
                        dense
                        onClick={(e) => setEditAnchor(e.currentTarget)}
                        selected={!!editAnchor}
                        sx={{ typography: 'body2' }}>
                        Edit
                    </MenuItem>
                )}
            </MenuList>
            {apiItems.length > 0 && (
                <Menu anchorEl={apiAnchor} open={!!apiAnchor} onClose={closeApi} slotProps={{ paper: menuProps }}>
                    {renderItems(apiItems, closeApi)}
                </Menu>
            )}
            {editItems.length > 0 && (
                <Menu anchorEl={editAnchor} open={!!editAnchor} onClose={closeEdit} slotProps={{ paper: menuProps }}>
                    {renderItems(editItems, closeEdit)}
                </Menu>
            )}
        </>
    );
}

export { AdminMenuBar };
